function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.902,
    height: 29.242,
    viewBox: "0 0 39.902 29.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "11d"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184496"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184492"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14443",
    d: "M469.444 191.467a4.252 4.252 0 0 0-4.2-3.289 4.37 4.37 0 0 0-2.674.9 7.609 7.609 0 0 0-6.8-4.072 7.486 7.486 0 0 0-7.515 6.364 5.054 5.054 0 0 0-4.052 4.866 5.105 5.105 0 0 0 5.184 4.99h9.227L457 198.964l5.47-1.947 1.36 3.821 2.313-.823.433 1.217h1.359a5.105 5.105 0 0 0 5.184-4.99 5.037 5.037 0 0 0-3.675-4.775z",
    transform: "translate(-444.205 -179.168)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184617"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14415",
    d: "M500.83 57.783a5.67 5.67 0 0 0-5.692-4.82 5.764 5.764 0 0 0-5.15 3.084 5.059 5.059 0 0 0-4.673 0c-2.6 1.217-1.809 4.805-1.809 4.858.813-.935 3.113-.811 4.192 0a5.592 5.592 0 0 1 2.645 4.346h9.631a3.867 3.867 0 0 0 3.927-3.78 3.83 3.83 0 0 0-3.071-3.688z",
    transform: "translate(-463.997 -52.963)",
    style: {
      fill: "#e06d6d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184455"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184454"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14416",
    d: "M530.241 57.808a3.751 3.751 0 0 1 3.473 2.463c.142.381.759.216.615-.17a4.41 4.41 0 0 0-4.088-2.932.319.319 0 0 0 0 .638z",
    transform: "translate(-498.657 -56.095)",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184495"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184493"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14444",
    d: "M468.361 191.691a6.011 6.011 0 0 1 4.869-2.6.36.36 0 0 0 0-.72 6.772 6.772 0 0 0-5.491 2.955c-.266.38.358.741.622.364z",
    transform: "translate(-461.683 -181.672)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184494"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14445",
    d: "M448.7 218.564a3.912 3.912 0 0 1 1.834-3.259c.389-.249.029-.872-.363-.622a4.656 4.656 0 0 0-2.191 3.881.36.36 0 0 0 .72 0z",
    transform: "translate(-447.013 -201.223)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14446",
    d: "m509.287 245.048-1.117-5.27-1.81.644-1.145-3.218-2.313.823-1.36-3.821-4.525 1.61 3.857 5.426 2.614-.93 1.564 2.8 1.911-.68z",
    transform: "translate(-483.536 -215.806)",
    style: {
      fill: "#283593"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11D);
export default __webpack_public_path__ + "static/media/11D.ed91f286e6e16473162efb4e58788a32.svg";
export { ForwardRef as ReactComponent };